export const colors = {
  primaryColor: " #ff0800",
  grey: "#aaaaaa",
  black: "#323232",
};
